import { createContext, PropsWithChildren, useContext } from "react";

export function contextFactory<T>(useStateBuilder: () => T | null) {
  const emptyValue = null;
  const MyContext = createContext<T>(emptyValue as unknown as T);

  function Provider({ children }: PropsWithChildren<{}>) {
    const state = useStateBuilder();
    if (state === null) return null;
    return <MyContext.Provider value={state}>{children}</MyContext.Provider>;
  }

  function useCustomContext() {
    const contextOpt = useContext(MyContext);
    const contextName = useStateBuilder.name || "UNKNOWN";
    if (contextOpt === emptyValue) {
      throw new Error(
        `context "${contextName}" is missing. Did you forget to include it?`
      );
    }
    return contextOpt;
  }
  return { Provider, useCustomContext, ProviderRaw: MyContext.Provider };
}
